<template>
  <draggable
    v-bind="dragOptions"
    tag="div"
    class="item-container"
    :list="list"
    :value="value"
    @input="emitter"
    handle=".svg-anchor"
  >
    <template v-for="el in realValue">
      <div class="item-group" :key="el.uuid">
        <row-element
          class="item-group_header"
          :element="el"
          :available-icons="availableIcons"
        >
          <template v-slot:anchor>
            <drug-n-drop-vertical-anchor class="svg-anchor" />
          </template>
        </row-element>
        <draggable-element
          class="item-group_children"
          :list="el.children.data"
          :available-icons="availableIcons"
        />
      </div>
    </template>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import RowElement from "./row-element";
import DrugNDropVerticalAnchor from "../../_snippets/drag-n-drop-archor/vertical";

export default {
  name: "DraggableElement",
  components: { RowElement, draggable, DrugNDropVerticalAnchor },
  props: {
    value: {
      required: false,
      type: Array,
      default: null
    },
    list: {
      required: false,
      type: Array,
      default: null
    },
    availableIcons: {
      type: Array,
      required: true
    }
  },
  methods: {
    emitter(value) {
      this.$emit("input", value);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    realValue() {
      return this.value ? this.value : this.list;
    }
  }
};
</script>

<style scoped lang="stylus">
.svg-anchor
    filter opacity(0.3)

.ghost
    background-color #f5f5f5
    padding 5px 0
    & .item-container
        background-color #f5f5f5

.item
    &-container
        background-color #ffffff
    &-group
        &_header
            display flex
            align-items center
            justify-content flex-start
        &:first-child &_header:not(.ghost)
            padding-top 10px
        &_children
            margin 0 0 0 1em
            padding-bottom 10px
</style>
